// Func = limiting Scope for this file
var lastScrollTop = 0;

var opened = 0;
var start = $('#arriveInput').attr('value');
var end = $('#departureInput').attr('value');

//parallax variables
var scrollParallaxH = [];
var lastScrollLeft = [];



var w=window,
d=document,
e=d.documentElement,
g=d.getElementsByTagName('body')[0],
windowWidth = w.innerWidth||e.clientWidth||g.clientWidth,
windowHeight = w.innerHeight||e.clientHeight||g.clientHeight;



(function(){


	//booking Container
	document.getElementById('bookingCta').addEventListener('click', function(){
		document.getElementById('bookingContainer').classList.add('open');
	});
	document.getElementById('bookingClose').addEventListener('click', function(){
		document.getElementById('bookingContainer').classList.remove('open');
	});

	//submenu header
	let allNavA = document.getElementById('primary-nav').getElementsByTagName('a');
	let allNavALength = allNavA.length;
	for(let h = 0; h < allNavALength; h++){
		
		if(window.innerWidth < 1200 ){ 
			allNavA[h].addEventListener('click', function(e){
				if(this.nextElementSibling.classList.contains('submenu')){
					e.preventDefault();
					if(!this.nextElementSibling.classList.contains('open')){
						this.nextElementSibling.classList.add('open')
					} else {
						this.nextElementSibling.classList.remove('open')
					}
				}
			});
		} else {
			allNavA[h].parentElement.addEventListener('mouseover', function(e){
				if(this.getElementsByClassName('submenu').length > 0){
				
					if(!this.getElementsByClassName('submenu')[0].classList.contains('open')){
						this.getElementsByClassName('submenu')[0].classList.add('open')
					}
					
				}
				
			});
			allNavA[h].parentElement.addEventListener('mouseleave', function(e){
				if(this.getElementsByClassName('submenu').length > 0){
				
					if(this.getElementsByClassName('submenu')[0].classList.contains('open')){
						this.getElementsByClassName('submenu')[0].classList.remove('open')
					}
					
				}
			});
		}
			
		
	}


	//*********    Intersection for parallax effect and other cool animations
	if(!(window.ActiveXObject) && "ActiveXObject" in window){
		//is explorer (-_-)
	}else {
		
		//parallax text
		if(document.getElementsByClassName('parallax-image').length > 0){
			if(window.innerWidth > 1090 ){
				let textOptions = {
					root : null,
					rootMargin : '0px',
					threshold : 0.1
				}
				function handlerParallaxText(entries, observer){
					for(let entry of entries){
						if (entry.isIntersecting) {
							parallaxImage(entry.target);
							
						} else {
							let id_elem = entry.target.getAttribute('parallax-id');
							window.addEventListener('scroll', scrollParallaxH[id_elem])
						}
					}
				}
				let allParallax = document.getElementsByClassName('parallax-image');
				for(let  j = 0; j < allParallax.length; j++ ){
					let observerP = new IntersectionObserver(handlerParallaxText, textOptions)
					observerP.observe(allParallax[j]);
				}
			}
		}
		
	}
	if(document.getElementById('burgerMenu')){
		document.getElementById('burgerMenu').addEventListener('click', function(){
			if(!document.getElementById('primary-nav').classList.contains('open')){
				document.getElementById('primary-nav').classList.add('open')
				this.classList.add('open');
				this.getElementsByClassName('text')[0].innerHTML = 'Close'
			} else {
				document.getElementById('primary-nav').classList.remove('open')
				this.classList.remove('open')
				this.getElementsByClassName('text')[0].innerHTML = 'Menu'
			}
		});
	}

	//email signup open
    document.getElementById('signupContainer').addEventListener('click', function(){
        document.getElementById('signupContainer').classList.add('open')
    });
    document.addEventListener('click', function(e){
        if(!document.getElementById('signupContainer').contains(e.target)){
            document.getElementById('signupContainer').classList.remove('open');
			
        }
    });


	$(document).ready(function () {

		//To create after event 
		$.datepicker._updateDatepicker_original = $.datepicker._updateDatepicker;
		$.datepicker._updateDatepicker = function (inst) {
			$.datepicker._updateDatepicker_original(inst);
			var afterShow = this._get(inst, 'afterShow');
			if (afterShow)
				afterShow.apply((inst.input ? inst.input[0] : null));  // trigger custom callback
		}
		$('#bookingCalendar').datepicker({
			changeMonth: false,
			dateFormat: 'mm-dd-yy',
			numberOfMonths: 2,
			minDate:0,
			beforeShowDay: function (date) {

				$.datepicker._defaults.dateFormat = "mm-dd-yy";
				var startDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
				var endDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
				if (date.getTime() == startDate.getTime()) {
					return [true, "startday"];
				} else {
					if (date.getTime() == endDate.getTime()) {
						return [true, "endday"];
					} else {
						if (date.getTime() > startDate.getTime() && date.getTime() < endDate.getTime()) {
							return [true, "days"];
						} else {
							return [true, ""];
						}
					}
				}
			},
			onSelect: function (date) {
				var arrive = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
				var departure = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
				var selectedDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, date);

				if (opened == 0) {
					opened = 1;
					start = date;
					end = date;
					
				} else {
					opened = 0;
					if (selectedDate <= arrive) {
						end = start;
						start = date;
					} else {
						end = date;
					}
				
					
				}
				$('#arriveInput').attr('value', start);
				$('#departureInput').attr('value', end);
			
				
			
			},
			onChangeMonthYear: function () {
				
			}
		});

	
});


	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

}());

function parallaxImage(target) {
	let id_elem = target.getAttribute('parallax-id');
	let temp = parseInt(target.getAttribute('data-parallax').split(',')[1]);
	

	let parallaxFunctionT = function(){
		
		let stp = window.pageYOffset || document.documentElement.scrollTop;

		if(lastScrollLeft[id_elem] === undefined){
			lastScrollLeft[id_elem] = parseInt(stp) - 1;
		}

		// console.log('scroll' + stp);
		// console.log('last' + lastScrollLeft[id_elem]);
		
		let direction = target.getAttribute('data-parallax').split(',')[0];
		if (stp > lastScrollLeft[id_elem]){
			
			temp = temp + (direction * 0.4);
			lastScrollLeft[id_elem] = stp - 1;
		} else {
			
			temp = temp - (direction * 0.4);
			lastScrollLeft[id_elem] = stp + 1;
		}
		//if(temp >= 0){
	
			target.setAttribute('style','transform:translateY(' + parseInt(temp) + 'px)');
			target.setAttribute('data-parallax',direction + ',' + parseInt(temp) );
		//}
		
		

	}
	

	scrollParallaxH[id_elem] = parallaxFunctionT
	window.addEventListener('scroll', scrollParallaxH[id_elem])	
	
}


function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if(!document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.add('down');
		}
	} else {
		if(document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}